import { createAction } from 'Lib/reduxUtils';

import {
  AUTHENTICATE_INSTAGRAM,
  // Instagram
  AUTHENTICATE_INSTAGRAM_SUCCESS,
  CONNECT_INSTAGRAM,
  DISCONNECT_INSTAGRAM,
  DISCONNECT_INSTAGRAM_SUCCESS,
  FETCH_INSTAGRAM_OAUTH_URL,
  FETCH_INSTAGRAM_OAUTH_URL_SUCCESS,
  PROMPT_DISCONNECT_INSTAGRAM,
  // Generic
  TOGGLE_REPLACE_PHOTO,
} from './constants';

export const toggleReplacePhoto = createAction(TOGGLE_REPLACE_PHOTO, (data: any) => data);

// Instagram
export const fetchInstagramOAuthUrl = createAction(FETCH_INSTAGRAM_OAUTH_URL);
export const fetchInstagramOAuthUrlSuccess = createAction(
  FETCH_INSTAGRAM_OAUTH_URL_SUCCESS,
  (url: string) => ({ url })
);
export const connectInstagram = createAction(CONNECT_INSTAGRAM);
export const promptDisconnectInstagram = createAction(PROMPT_DISCONNECT_INSTAGRAM);
export const disconnectInstagram = createAction(DISCONNECT_INSTAGRAM);
export const disconnectInstagramSuccess = createAction(
  DISCONNECT_INSTAGRAM_SUCCESS,
  (data: any) => data
);
export const authenticateInstagram = createAction(AUTHENTICATE_INSTAGRAM, (code: string) => ({
  code,
}));
export const authenticateInstagramSuccess = createAction(
  AUTHENTICATE_INSTAGRAM_SUCCESS,
  (data: any) => data
);
